<h2 class="title">{{ title }}</h2>
<p class="paragraph2">Step <span>{{ currentStep }}</span> of {{ totalSteps }}</p>